export const SITE_URL = "helpermemoveph.maximquiz.com";
export const GO_URL = "https://forms.gle/GsjjP9CKgYpWm8BS8";
